<template>
  <div class="layout-sidebar">
    <app-menu/>
  </div>
</template>

<script setup lang="ts">
import AppMenu from './AppMenu.vue'
</script>

<style lang="scss" scoped></style>
